import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalSignedInEmployeeDocument = gql`
  query SalesPortalSignedInEmployee($userUUID: uuid!) {
    employees_by_pk(uuid: $userUUID) {
      uuid
      name
    }
  }
`;
export function useSalesPortalSignedInEmployeeQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalSignedInEmployeeQuery,
    Types.SalesPortalSignedInEmployeeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalSignedInEmployeeQuery,
    Types.SalesPortalSignedInEmployeeQueryVariables
  >(SalesPortalSignedInEmployeeDocument, options);
}
export function useSalesPortalSignedInEmployeeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalSignedInEmployeeQuery,
    Types.SalesPortalSignedInEmployeeQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalSignedInEmployeeQuery,
    Types.SalesPortalSignedInEmployeeQueryVariables
  >(SalesPortalSignedInEmployeeDocument, options);
}
export type SalesPortalSignedInEmployeeQueryHookResult = ReturnType<
  typeof useSalesPortalSignedInEmployeeQuery
>;
export type SalesPortalSignedInEmployeeLazyQueryHookResult = ReturnType<
  typeof useSalesPortalSignedInEmployeeLazyQuery
>;
export type SalesPortalSignedInEmployeeQueryResult = Apollo.QueryResult<
  Types.SalesPortalSignedInEmployeeQuery,
  Types.SalesPortalSignedInEmployeeQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalSignedInEmployeeQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalSignedInEmployeeQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalSignedInEmployeeQuery,
    Types.SalesPortalSignedInEmployeeQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalSignedInEmployeeQuery,
    Types.SalesPortalSignedInEmployeeQueryVariables
  >(SalesPortalSignedInEmployeeDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalSignedInEmployeeLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalSignedInEmployeeLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalSignedInEmployeeQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalSignedInEmployeeQuery,
    Types.SalesPortalSignedInEmployeeQueryVariables
  >(SalesPortalSignedInEmployeeDocument, lazyOptions);
}
